/**
 * ProgressIndicator Component
 *
 * Status: [IMPLEMENTED]
 * Task: T2.8.7 - Add progress indicator
 *
 * Shows a loading spinner with status message during resume generation.
 */

import React from 'react';

const ProgressIndicator = ({ message = 'Generating resume...' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      {/* Spinner */}
      <div className="relative">
        <div className="w-16 h-16 border-4 border-slate-600 border-t-sky-500 rounded-full animate-spin"></div>
      </div>

      {/* Message */}
      <p className="mt-6 text-lg text-slate-300 font-medium">
        {message}
      </p>

      {/* Animated dots */}
      <div className="mt-2 flex gap-1">
        <span className="w-2 h-2 bg-sky-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
        <span className="w-2 h-2 bg-sky-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
        <span className="w-2 h-2 bg-sky-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
      </div>

      {/* Helpful tip */}
      <p className="mt-6 text-sm text-slate-500">
        This may take up to 30 seconds
      </p>
    </div>
  );
};

export default ProgressIndicator;
